import React, { Component } from 'react'
import {
  processDataCollection,
  selectDataCollection,
  selectDataCollectionGroup,
  unselectDataCollection,
  unselectDataCollectionGroup,
} from '../actions/application.js'

import { DataCollectionGroupPanel } from '../components/Mx/DataCollectionGroup/DataCollectionGroupPanel.js'
import LazyLoad from 'react-lazyload'
import Loader from 'react-loader-advanced'
import PropTypes from 'prop-types'
import { axios } from 'config/axios'
import { connect } from 'react-redux'
import { getMXDataColletionGroupBySessionId } from '../api/ispyb.js'
import { parseDatasets } from '../helpers/Mx/MXDatasetHelper.js'
import { setBreadCrumbs } from '../actions/breadcrumbs.js'

class MXSessionsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fetching: true,
      fetched: false,
      experiments: [],
      datasets: [],
      error: null,
    }
  }

  /**
   * This method will retrieve the experiments for a given session
   * A experiment might be calibration, sample changer or HPLC
   */
  componentDidMount() {
    const _this = this

    _this.setState({
      fetching: true,
      fetched: false,
    })

    axios({
      method: 'GET',
      url: getMXDataColletionGroupBySessionId(this.props.user, this.props.proposal, this.props.sessionId),
    })
      .then(function (response) {
        _this.setState({
          datasets: parseDatasets(_this.props.proposals.data, response.data),
          fetching: false,
          fetched: true,
        })
      })
      .catch(function (error) {
        _this.setState({
          error: error,
          fetching: false,
          fetched: false,
        })
      })
  }

  render() {
    if (!this.props.user || !this.props.user.token) {
      return null
    }

    if (this.state.fetching) {
      return (
        <Loader show={this.state.fetching} message="Loading Sessions">
          ..
        </Loader>
      )
    }

    if (this.state.datasets.length === 0) {
      return 'No data collections'
    }

    return (
      <div style={{ marginBottom: '100px' }}>
        {this.state.datasets.map((value, index) => (
          <div style={{ marginBottom: '20px' }} key={index}>
            <LazyLoad height={200} offset={100} once>
              <DataCollectionGroupPanel
                selectDataCollectionGroup={this.props.selectDataCollectionGroup}
                unselectDataCollectionGroup={this.props.unselectDataCollectionGroup}
                selectDataCollection={this.props.selectDataCollection}
                unselectDataCollection={this.props.unselectDataCollection}
                processDataCollectionGroup={this.props.processDataCollectionGroup}
                processDataCollection={this.props.processDataCollection}
                application={this.props.application}
                proposal={this.props.proposal}
                sessionId={this.props.sessionId}
                user={this.props.user}
                datacollectiongroup={value}
                configuration={this.props.configuration}
                jobs={this.props.jobs}
              />
            </LazyLoad>
          </div>
        ))}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    application: state.application,
    proposals: state.proposals,
    configuration: state.configuration,
    jobs: state.jobs,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadCrumbs: breadCrumbs => dispatch(setBreadCrumbs(breadCrumbs)),
    selectDataCollectionGroup: dataCollection => dispatch(selectDataCollectionGroup(dataCollection)),
    unselectDataCollectionGroup: dataCollection => dispatch(unselectDataCollectionGroup(dataCollection)),
    selectDataCollection: dataCollection => dispatch(selectDataCollection(dataCollection)),
    unselectDataCollection: dataCollection => dispatch(unselectDataCollection(dataCollection)),
    processDataCollection: dataCollection => dispatch(processDataCollection(dataCollection)),
  }
}

MXSessionsContainer.propTypes = {
  sessionId: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(MXSessionsContainer)
